module.exports = __webpack_public_path__ + "img/lr-cb66-110.f3f3a65e.gif";